import { format, parseISO } from "date-fns";

export const getFormattedStartTime = (startTime: string | undefined) => {
  return startTime ? format(parseISO(startTime), "yyyy/MM/dd hh:mm:ss aaaa") : startTime;
};
